import { MassTortCustomFieldsListView } from "@/components/features/mass-torts/MassTortCustomFieldsListView";
import { Card, CardContent, Typography } from "@/components/ui";
import LawWorksLoader from "@/components/ui/LawWorksLoader/LawWorksLoader";
import { useUser } from "@/components/UserProvider";
import { retrieveMassTortQueryOptions } from "@/lib/data/react-query/mass-torts/mass-tort";
import { PAGE_PERMISSION_KEYS } from "@/lib/data/static/permissionOptions";
import { useQuery } from "@tanstack/react-query";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute(
  "/_auth/mass-torts/$massTortSearchId/_layout/custom-fields",
)({
  component: RouteComponent,
});

function RouteComponent() {
  const { massTortSearchId: massTortId } = Route.useParams();
  const { hasPagePermission } = useUser();
  const canViewCustomFields = hasPagePermission(
    PAGE_PERMISSION_KEYS.massTortsDetailCustomFields,
  );
  const { data: massTortResponse, isLoading: isMassTortLoading } = useQuery({
    ...retrieveMassTortQueryOptions(massTortId),
  });

  const massTort = massTortResponse?.data;
  const isPageLoading = Boolean(massTortId && isMassTortLoading);

  if (isPageLoading) {
    return <LawWorksLoader className="w-full" />;
  }

  if (!canViewCustomFields) {
    return (
      <div className="grid h-screen w-full grid-cols-1 gap-4 p-6">
        <Card className="flex h-full flex-col">
          <CardContent className="flex h-full flex-col items-center justify-center gap-2 text-center">
            <Typography variant="subHeading">
              Mass tort custom fields
            </Typography>
            <Typography className="text-muted-foreground">
              You do not have permission to view custom fields.
            </Typography>
          </CardContent>
        </Card>
      </div>
    );
  }

  if (!massTortId || !massTort) {
    return (
      <div className="grid h-screen w-full grid-cols-1 gap-4 p-6">
        <Card className="flex h-full flex-col">
          <CardContent className="flex h-full flex-col items-center justify-center gap-2 text-center">
            <Typography variant="subHeading">
              Mass tort custom fields
            </Typography>
            <Typography className="text-muted-foreground">
              Unable to load custom fields for this mass tort.
            </Typography>
          </CardContent>
        </Card>
      </div>
    );
  }

  return (
    <div className="flex h-screen min-h-0 flex-col p-4 sm:p-6">
      <div className="border-border bg-card flex min-h-0 flex-1 flex-col overflow-hidden rounded-xl border p-4 shadow-xs sm:p-6">
        <div className="mb-4 flex shrink-0 flex-col gap-1">
          <Typography variant="subHeading" className="text-xl">
            Custom fields
          </Typography>
          <Typography className="text-muted-foreground text-sm">
            Configure the custom dropdown fields available for this mass tort.
          </Typography>
        </div>
        <div className="min-h-0 flex-1 overflow-auto">
          <MassTortCustomFieldsListView
            massTortId={massTortId}
            massTortCustomFields={massTort.customFields}
          />
        </div>
      </div>
    </div>
  );
}
